module.exports = __webpack_public_path__ + "img/git.adcab6a5.svg";